import { AboutAction } from '../model/aboutReducer';
import { AboutModel } from '../model/aboutModel';

export const aboutViewModel = {
  loadContent: async (
    dispatch: React.Dispatch<AboutAction>,
    fetchFunction: () => Promise<AboutModel>,
    errorMessage: string
  ) => {
    dispatch({ type: 'FETCH_START' });

    try {
      const model = await fetchFunction();
      dispatch({ type: 'FETCH_SUCCESS', payload: model });
    } catch {
      dispatch({
        type: 'FETCH_ERROR',
        payload: errorMessage
      });
    }
  }
};